import { Color } from '@diritto/common/style/color';

export const VerticalDivider = ({ color = Color.Gray300, size = 10 }: { color?: string; size?: number }) => (
  <svg width="1" height={size} viewBox={`0 0 1 ${size}`} fill="none" xmlns="http://www.w3.org/2000/svg">
    <line x1="0.5" x2="0.5" y2={size} stroke={color} />
  </svg>
);
